export default {
  slug: 'ws-google-map-embed',
  PANEL_HEIGHT: 48,
  MODAL_WIDTH: 570,
  MODAL_HEIGHT: 512,
  BASE_MAP_HREF: 'https://www.google.com/maps/embed/v1/place',
  MODAL_TYPE: '@WS_GOOGLE_MAP_EMBED/PREVIEW_DIALOG',
  DEFAULT_QUERY_SELECTOR: 'ws-iframe[src^="https://www.google.com/maps/embed"]',
};
